module.exports = __webpack_public_path__ + "static/img/4337_phase_function_Paper_Points.0df59ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4337_phase_function_Paper_Points.png
// module id = i/Uy
// module chunks = 0